export default __webpack_public_path__ + "justhatched-devices_tablet.fb75a48b.png";